import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import BlueBannerLogo from "../../assets/logos/BlueBanner.png";
import OnboardingBgMobile from "../../assets/onboarding-bg-mobile.webp";
import OnboardingBg from "../../assets/onboarding-bg.webp";
import { OnboardingForm } from "../../components/onboarding/OnboardingForm";

export const Onboarding = () => {
  const [isSignupComplete, setIsSignupComplete] = useState(false);

  return (
    <Box
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      width="100%"
      sx={{
        backgroundImage: {
          xs: `url(${OnboardingBgMobile})`,
          md: `url(${OnboardingBg})`
        },
        backgroundColor: "#F0F8F7",
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >
      <style>
        {`
          .grecaptcha-badge {
            bottom: auto !important;
            top: 4px !important;
          }
        `}
      </style>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box
            color="white"
            py={{ xs: 0, md: 19 }}
            px={{ xs: 2, md: 10 }}
            pt={{ xs: 6 }}
          >
            <Typography
              variant="h2"
              fontSize={{ xs: 30, sm: 40, md: 40, lg: 50, xl: 60 }}
              fontFamily="Poppins"
              color="primary.dark"
              fontWeight={600}
            >
              Begin your employee wellbeing journey!
            </Typography>
            <Typography
              variant="h5"
              fontSize={{ xs: 18, sm: 24, xl: 30 }}
              my={2}
              fontFamily="Poppins"
              color="primary.dark"
              fontWeight={400}
            >
              Blah blah blah blah blah blah blah blah
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            bgcolor="white"
            borderRadius={3}
            py={{ xs: 5, md: 7 }}
            my={{ xs: 0, md: 7 }}
            mx={{ xs: 2, md: 10 }}
            ml={{ xs: 2, md: 0 }}
            px={3}
          >
            <Grid
              item
              mb={{ xs: 5, md: 7 }}
              display="flex"
              justifyContent="center"
            >
              <img src={BlueBannerLogo} alt="HeathNow logo" width={200} />
            </Grid>
            {!isSignupComplete ? (
              <OnboardingForm
                setSignupComplete={() => setIsSignupComplete(true)}
              />
            ) : (
              <Box>
                <Typography variant="h6" textAlign="center" my={10} mx={5}>
                  Thank you. Our Customer Success team have been notified and
                  will be in touch soon about next steps to get you setup on
                  HealthNow
                </Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
